export default __webpack_public_path__ + "static/media/X.d689c2da.svg";